<template>
  <div class="a-vs-c--rating-bottom">
    <div v-for="(game, index) in gameRasult" :key="index" class="a-vs-c--single-result">
      <span>{{ game.letter }}</span>
      <div :class="game.winClass"></div>
      <div class="result">
        <span :class="game.homeClass">{{ game.homeTeam }}:</span>
        <span :class="game.awayClass">{{ game.awayTeam }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    winsTeam: {
      type: Array,
      default: function () {
        return []
      }
    },
    teamGoalsHomeTeam: {
      type: Array,
      default: function () {
        return []
      }
    },
    teamGoalsAwayTeam: {
      type: Array,
      default: function () {
        return []
      }
    },
    teamPlayedHome: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    gameRasult: function () {
      let result = []
      for (let i = 0; i < 5; i++) {
        result.push({
          'letter': this.getLetter(i),
          'winClass': this.getWinClass(i),
          'homeClass': this.getResultClassHome(i),
          'awayClass': this.getResultClassAway(i),
          'homeTeam': this.teamGoalsHomeTeam[i],
          'awayTeam': this.teamGoalsAwayTeam[i]
        })
      }
      return result
    }
  },
  methods: {
    getResultClassAway: function (index) {
      if (this.teamPlayedHome[index] === 1 || this.winsTeam[index] === 1) {
        return ''
      } else if (this.teamPlayedHome[index] === 0 && this.winsTeam[index] === 0) {
        return 'a-vs-f-danger-secondary'
      } else {
        return 'a-vs-f-success-secondary'
      }
    },
    getResultClassHome: function (index) {
      if (this.teamPlayedHome[index] === 0 || this.winsTeam[index] === 1) {
        return ''
      } else if (this.teamPlayedHome[index] === 1 && this.winsTeam[index] === 0) {
        return 'a-vs-f-danger-secondary'
      } else {
        return 'a-vs-f-success-secondary'
      }
    },
    getWinClass: function (index) {
      switch (this.winsTeam[index]) {
        case 0:
          return 'a-vs-c-danger-secondary'
        case 1:
          return 'a-vs-c-neutral-secondary'
        case 2:
          return 'a-vs-c-success-secondary'
      }
    },
    getLetter: function (index) {
      switch (this.winsTeam[index]) {
        case 0:
          return this.$t('l')
        case 1:
          return this.$t('d')
        case 2:
          return this.$t('w')
      }
    }
  }
}
</script>
